module.exports = __webpack_public_path__ + "src/assets/games/24/355.jpg";